// removed by extract-text-webpack-plugin
module.exports = {"link":"RequestMoreInfoLinks__link__UFUB6"};


//////////////////
// WEBPACK FOOTER
// ./assets/js/contact/dealer/styles/RequestMoreInfoLinks.scss
// module id = 2972
// module chunks = 4